import i18n from 'i18next'

export const t = (text: string, options?: Record<string, any>): string => i18n.t(text, options)
